import { QueryParamsType } from "@/types"
import { FacetsType } from "@/types/ElasticSearch/SearchAPIResponse"

export const getClearAllUrls: (p: {
  slug?: string,
  legacyId?: string,
  isSearch?: boolean,
  queryParam: QueryParamsType,
}) => {
  clearFilterHref: string
  clearFilterUrl: string
} = ({
  slug, legacyId, isSearch = false, queryParam,
}) => {
    let visibleQuery = ''
    const searchQuery = queryParam?.query || ''
    const searchRoute = `/search.php?query=${searchQuery || ''}`

    if (queryParam?.readyToShip === '1') {
      let helper = new URLSearchParams()
      helper.set('readyToShip', '1')
      visibleQuery = helper.toString()
    }

    const clearFilterHref = isSearch
      ? `${searchRoute}`
      : (legacyId
        ? `/category?slug=${slug}&legacyId=${legacyId}${visibleQuery ? `&${visibleQuery}` : ''}`
        : `/category?slug=${slug}${visibleQuery ? `&${visibleQuery}` : ''}`)

    const clearFilterUrl = isSearch
      ? clearFilterHref
      // category page
      : legacyId
        ? `/c-${legacyId}-${slug}?${visibleQuery}`
        : `/c-${slug}?${visibleQuery}`

    return { clearFilterHref, clearFilterUrl }
  }

export const getAppliedFilterUrls: (p: {
  slug?: string,
  legacyId?: string,
  isSearch?: boolean,
  queryParam: QueryParamsType,
  query: string
}) => {
  href: string
  url: string
} = ({
  slug, legacyId, query, isSearch = false, queryParam
}) => {
    const searchQuery = queryParam?.query || ''
    const searchRoute = `/search.php?query=${searchQuery || ''}`
    const href = isSearch
      ? `${searchRoute}&${query}`
      : (legacyId
        ? `/category?slug=${slug}&legacyId=${legacyId}${query ? `&${query}` : ''}`
        : `/category?slug=${slug}${query ? `&${query}` : ''}`)

    const url = isSearch
      ? href
      // category page
      : legacyId
        ? `/c-${legacyId}-${slug}?${query || ''}`
        : `/c-${slug}?${query || ''}`

    return { href, url }
  }

export const DEFAULT_SORT = 'bestSelling'

export const IGNORED_FILTERS = [
  'DSI',
  'NSI',
  'Ready to Ship',
]

// eslint-disable-next-line
const price_range = {
  'under $20': 0,
  '$20 - $39': 1,
  '$40 - $59': 2,
  '$60 - $79': 3,
  '$80 - $99': 4,
  '$100 - $249': 5,
  '$250 - $499': 6,
  '$500 - $749': 7,
  '$750 - $999': 8,
  '$1000 - $1499': 9,
  '$1500 - $2999': 10,
  'over $3000': 11,
}

const heightWidthRange = {
  'Up to 10 inches': 0,
  '10.01 to 20 inches': 1,
  '20.01 to 30 inches': 2,
  '30.01 to 40 inches': 3,
  '40.01 to 50 inches': 4,
  '50.01 to 60 inches': 5,
  '60.01 to 70 inches': 6,
  '70.01 to 80 inches': 7,
  '80.01 to 90 inches': 8,
  '90.01 inches and more': 9,
}

export const sortFacetByMatch = (facet: FacetsType): FacetsType => {
  try {
    const orderings = {
      price_range,
      heightRange: heightWidthRange,
      widthRange: heightWidthRange,
    }
    const orderingForFacet = orderings[facet.machineName]
    if (!orderingForFacet) {
      throw new Error('No matching sort config, abort')
    }

    let sorted = Array(facet.available.length).fill(null)
    facet.available.forEach((entry) => {
      const order = orderingForFacet[entry.key]
      if (typeof order !== 'number') {
        throw new Error('No matching sort order, abort')
      }
      sorted[order] = entry
    })
    sorted = sorted.filter((item) => !!item)
    return {
      ...facet,
      available: sorted,
    }
  } catch (e) {
    return facet
  }
}
